module.exports = __webpack_public_path__ + "img/location_a03.456fab90.svg";